import React from "react";
import { useCatalogSkeletonStyles } from "./CatalogSkeleton.styles";
import { CatalogSkeletonProps } from "./types";

const CatalogSkeleton: React.FC<CatalogSkeletonProps> = ({ count = 8 }) => {
  const classes = useCatalogSkeletonStyles();

  return (
    <div className={classes.grid}>
      {Array.from({ length: count }).map((_, index) => (
        <div className={classes.card} key={index}>
          <div className={classes.image} />

          <div className={classes.content}>
            <div className={`${classes.line} ${classes.short}`} />
            <div className={classes.line} />
            <div className={`${classes.line} ${classes.medium}`} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default CatalogSkeleton;
